import * as React from 'react';
import styles from './index.less';
import FComponentsLib from '@freelog/components-lib';
import { FI18n, FUtil } from '@freelog/tools-lib';
import fMessage from '@/components/fMessage';
import FUploadCover from '@/components/FUploadCover';
import FResourceLabelEditor from '@/components/FResourceLabelEditor';
import { connect } from 'dva';
import { ConnectState, ResourceCreatorPageModelState } from '@/models/connect';
import { Dispatch } from 'redux';
import {
  ChangeAction,
  OnChange_step4_resourceCover_Action,
  OnChange_step4_resourceLabels_Action,
  OnClick_step4_preBtn_Action,
  OnClick_step4_submitBtn_Action,
} from '@/models/resourceCreatorPage';
import FCoverImage from '@/components/FCoverImage';
import FInProcessModal from '@/components/FInProcessModal';
import { history } from 'umi';
import FHotspotTooltip, { fSetHotspotTooltipVisible } from '@/components/FHotspotTooltip';
import FIcons from '@/components/FIcons';
import fEditLabelsDrawer from '@/components/fEditLabelsDrawer';
import ResourceLabelsCard from '@/components/FResourceLabelsCard';

interface Step4Props {
  dispatch: Dispatch;
  resourceCreatorPage: ResourceCreatorPageModelState;
}

function Step4({ dispatch, resourceCreatorPage }: Step4Props) {
  const [$inProcessModal, set$inProcessModal] = FUtil.Hook.useGetState<boolean>(false);

  return (
    <>
      <div style={{ height: 40 }} />

      <div className={styles.block}>
        <FComponentsLib.FContentText
          text={FI18n.i18nNext.tAuto('rqr_input_resouce_image')}
          type={'highlight'}
        />
        <div style={{ height: 5 }} />
        <FComponentsLib.FContentText
          text={FI18n.i18nNext.tAuto('rqr_input_resouce_image_help')}
          type={'additional2'}
        />
        <div style={{ height: 20 }} />
        <FUploadCover
          onUploadSuccess={(url) => {
            dispatch<OnChange_step4_resourceCover_Action>({
              type: 'resourceCreatorPage/onChange_step4_resourceCover',
              payload: {
                value: url,
              },
            });
          }}
          onError={(err) => {
            fMessage(err, 'error');
          }}
        >
          {resourceCreatorPage.step4_resourceCover === '' && (
            <a className={styles.FUploadImageChildren}>
              <FIcons.FCloudUpload />
              <span>{FI18n.i18nNext.tAuto('upload_image')}</span>
            </a>
          )}

          {resourceCreatorPage.step4_resourceCover !== '' && (
            <div className={styles.cover}>
              <FCoverImage
                src={resourceCreatorPage.step4_resourceCover}
                width={200}
                style={{ borderRadius: 4 }}
              />
              <div className={styles.coverEdit}>
                <FIcons.FEdit style={{ fontSize: 32 }} />
                <div style={{ height: 10 }} />
                <div>{FI18n.i18nNext.tAuto('btn_edit_cover')}</div>
              </div>
            </div>
          )}
        </FUploadCover>
      </div>

      <div style={{ height: 5 }} />

      <div className={styles.block}>
        <FComponentsLib.FContentText
          text={FI18n.i18nNext.tAuto('resource_short_description')}
          type={'highlight'}
        />
        <div style={{ height: 20 }} />
        <div>
          <FComponentsLib.FInput.FMultiLine
            value={resourceCreatorPage.step4_resourceIntroduction}
            lengthLimit={200}
            onChange={(e) => {
              dispatch<ChangeAction>({
                type: 'resourceCreatorPage/change',
                payload: {
                  step4_resourceIntroduction: e.target.value,
                },
              });
            }}
          />
        </div>
      </div>

      <div style={{ height: 5 }} />

      <div className={styles.block}>
        <FComponentsLib.FContentText
          text={
            // 资源标签
            FI18n.i18nNext.tAuto('rqr_input_resouce_tag')
          }
          type={'highlight'}
        />
        <div style={{ height: 20 }} />

        {/* <FResourceLabelEditor
          value={resourceCreatorPage.step4_resourceLabels}
          resourceTypeCode={resourceCreatorPage.step1_createdResourceInfo?.resourceTypeCode || ''}
          onChange={(value) => {
            dispatch<OnChange_step4_resourceLabels_Action>({
              type: 'resourceCreatorPage/onChange_step4_resourceLabels',
              payload: {
                value: value,
              },
            });
          }}
        /> */}

        {resourceCreatorPage.step4_resourceLabels.length === 0 && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
            }}
          >
            <FComponentsLib.FContentText
              text={
                // 标签是描述型关键字，添加标签有助于人们找到您的资源。
                FI18n.i18nNext.tAuto('rqr_input_resouce_tag_empty_msg')
              }
              type={'additional2'}
            />

            <div style={{ height: 20 }} />
            <FComponentsLib.FRectBtn
              type='primary'
              onClick={async () => {
                const result: null | string[] = await fEditLabelsDrawer({
                  labels: [],
                  resourceTypeCode:
                    resourceCreatorPage.step1_createdResourceInfo?.resourceTypeCode || undefined,
                });
                if (result === null) {
                  return;
                }

                dispatch<OnChange_step4_resourceLabels_Action>({
                  type: 'resourceCreatorPage/onChange_step4_resourceLabels',
                  payload: {
                    value: result,
                  },
                });
              }}
            >
              {
                // 添加标签
                FI18n.i18nNext.tAuto('rqr_input_resouce_tag_empty_btn')
              }
            </FComponentsLib.FRectBtn>
          </div>
        )}

        {resourceCreatorPage.step4_resourceLabels.length > 0 && (
          <ResourceLabelsCard
            labels={resourceCreatorPage.step4_resourceLabels || []}
            onClick={async () => {
              const result: null | string[] = await fEditLabelsDrawer({
                labels: resourceCreatorPage.step4_resourceLabels || [],
                resourceTypeCode:
                  resourceCreatorPage.step1_createdResourceInfo?.resourceTypeCode || undefined,
              });
              if (result === null) {
                return;
              }

              dispatch<OnChange_step4_resourceLabels_Action>({
                type: 'resourceCreatorPage/onChange_step4_resourceLabels',
                payload: {
                  value: result,
                },
              });
            }}
          />
        )}
      </div>

      <div style={{ height: 30 }} />

      <div className={styles.btn}>
        <FComponentsLib.FTextBtn
          type={'default'}
          onClick={() => {
            history.push(
              FUtil.LinkTo.resourceVersionInfo({
                resourceID: resourceCreatorPage.step1_createdResourceInfo?.resourceID || '',
                version: '1.0.0',
              }),
            );
          }}
        >
          {FI18n.i18nNext.tAuto('rqr_step3_btn_later')}
        </FComponentsLib.FTextBtn>

        <FComponentsLib.FTextBtn
          type={'default'}
          onClick={() => {
            dispatch<OnClick_step4_preBtn_Action>({
              type: 'resourceCreatorPage/onClick_step4_preBtn',
            });
          }}
        >
          {FI18n.i18nNext.tAuto('rqr_step4_btn_back')}
        </FComponentsLib.FTextBtn>

        <FHotspotTooltip
          id={'resourceCreator.step4.onlineButton'}
          style={{ left: 32, top: -38 }}
          text={FI18n.i18nNext.tAuto('hotpots_rqr_info_done')}
          onOpenChange={(o) => {
            if (o) {
              fSetHotspotTooltipVisible('resourceCreator.step4.onlineButton', {
                value: false,
                effectiveImmediately: false,
                onlyNullish: false,
              });
            }
          }}
          placement={'topRight'}
        >
          <FComponentsLib.FRectBtn
            disabled={resourceCreatorPage.step4_resourceIntroduction.length > 200}
            type={'primary'}
            onClick={async () => {
              if (resourceCreatorPage.step3_policies.length > 0) {
                set$inProcessModal(true);
                await FUtil.Tool.promiseSleep(500);
              }
              dispatch<OnClick_step4_submitBtn_Action>({
                type: 'resourceCreatorPage/onClick_step4_submitBtn',
              });
            }}
          >
            {FI18n.i18nNext.tAuto('rqr_step4_btn_release')}
          </FComponentsLib.FRectBtn>
        </FHotspotTooltip>
      </div>
      <div style={{ height: 200 }} />

      <FInProcessModal open={$inProcessModal} />
    </>
  );
}

export default connect(({ resourceCreatorPage }: ConnectState) => ({
  resourceCreatorPage: resourceCreatorPage,
}))(Step4);
